var _rect, _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaqsDotsLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "25px",
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0) scale(1, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 24.1797,
    width: 24,
    height: 24,
    rx: 12,
    transform: "rotate(-90 0 24.1797)",
    fill: "#dddddd"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 16.8464,
    r: 1.33333,
    transform: "rotate(-90 11.9998 16.8464)",
    fill: "#7b7b7b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 12.1803,
    r: 1.33333,
    transform: "rotate(-90 11.9998 12.1803)",
    fill: "#7b7b7b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 11.9998,
    cy: 7.51237,
    r: 1.33333,
    transform: "rotate(-90 11.9998 7.51237)",
    fill: "#7b7b7b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqsDotsLight);
export default __webpack_public_path__ + "static/media/faqs_dots_light.372934bb648c3818cfb97ede726445ca.svg";
export { ForwardRef as ReactComponent };